module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e450a0417017497cdfcc47d6fcbe2b34.png";